"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartBoxScoreQOpCard = void 0;
const calcUniqueKeyForViewField_1 = __importDefault(require("@opsbase/lib-data-viewfield/helpers/calcUniqueKeyForViewField"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const react_1 = __importStar(require("react"));
const ScoreQOpChart_1 = __importDefault(require("../ScoreQOpChart"));
function ChartBoxScoreQOpCard(props) {
    const { chart } = props;
    const dt = (0, useDataTree_1.default)();
    const { updateChart, toggleHighlightedField } = (0, useViewActions_1.default)(dt.viewId);
    const { highlightedField, fields } = (0, useView_1.default)(dt.viewId);
    const highlightYId = highlightedField ? (0, calcUniqueKeyForViewField_1.default)(highlightedField) : undefined;
    const pageOffset = dt.rootNode.page * dt.pageSize;
    (0, react_1.useEffect)(() => {
        var _a;
        if (((_a = chart === null || chart === void 0 ? void 0 : chart.config) === null || _a === void 0 ? void 0 : _a.pageOffset) !== pageOffset) {
            updateChart(Object.assign(Object.assign({}, chart), { config: Object.assign(Object.assign({}, chart.config), { pageOffset }) }));
        }
    }, [chart, pageOffset, updateChart]);
    const handleChangeInverse = (0, react_1.useCallback)(v => {
        updateChart(Object.assign(Object.assign({}, chart), { config: { inverse: v === '1' } }));
    }, [chart, updateChart]);
    const handleClickValue = (0, react_1.useCallback)(d => {
        toggleHighlightedField(fields.find(f => (0, calcUniqueKeyForViewField_1.default)(f) === d.y.id) || undefined);
    }, [toggleHighlightedField, fields]);
    return (0, react_1.useMemo)(() => {
        var _a;
        return (react_1.default.createElement(Vertical_1.default, { centered: true, gutter: true },
            react_1.default.createElement(Pane_1.default, { center: true },
                react_1.default.createElement(Select_1.default, { small: true, value: ((_a = chart === null || chart === void 0 ? void 0 : chart.config) === null || _a === void 0 ? void 0 : _a.inverse) ? '1' : '0', onChange: handleChangeInverse },
                    react_1.default.createElement(MenuItem_1.default, { value: '0' }, "Points Scored"),
                    react_1.default.createElement(MenuItem_1.default, { value: '1' }, "Points Missed"))),
            react_1.default.createElement(ScoreQOpChart_1.default, { chart: chart, highlightYId: highlightYId, onClickValue: handleClickValue, height: 200 })));
    }, [highlightYId, chart, handleChangeInverse, handleClickValue]);
}
exports.ChartBoxScoreQOpCard = ChartBoxScoreQOpCard;
exports.default = ChartBoxScoreQOpCard;
